import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-activate-document-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './activate-document-modal.component.html',
  styleUrl: './activate-document-modal.component.css'
})
export class ActivateDocumentModalComponent {
  @Input() collectionName!: string;
  @Input() documentName!: string;
  @Output() activateConfirmed = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal) {}

  onCancel(): void { this.activeModal.dismiss(); }

  onActivate(): void {
    this.activateConfirmed.emit();
  }
}


